import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import copyToClipBoard from '../utils/copyToClipBoard';

type Props = {
  children: ReactNode;
};

function RouteErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div style={{ padding: 20 }} data-testid="route-error-boundary">
      <p>An unexpected error occurred:</p>
      <button type="button" className="button secondary" onClick={resetErrorBoundary} style={{ display: 'block', margin: '1em 0' }} data-testid="route-error-retry">
        Click here to retry the page.
      </button>
      <button type="button" className="button secondary" style={{ display: 'block', margin: '1em 0' }} onClick={() => copyToClipBoard(error?.stack||'???')} data-testid="route-error-copy-details">
        Click here to copy the error data to send to IT.
      </button>
      <pre style={{ color: 'red' }} data-testid="route-error-stack">{error?.stack}</pre>
    </div>
  );
}

export default function RouteErrorBoundary({ children }: Props) {
  return (
    <ErrorBoundary
      FallbackComponent={RouteErrorFallback}
      onError={(error) => console.log(error)}
    >
      {children}
    </ErrorBoundary>
  );
}
